import React from "react";

import PageHeader from "../../../../molecules/PatientDetailsV2/PageHeader/PageHeader";

import RedirectComponent from "../../../../atoms/RedirectComponent/RedirectComponent";

const StepsTaskPage: React.FC<any> = () => {
  return (
    <div>
      <PageHeader title="Steps" />
      <RedirectComponent moduleName="steps" />
    </div>
  );
};

export default StepsTaskPage;
